import { v4 as uuidv4 } from 'uuid';
import { getPeriodoYYYYMM, buildFechaCarga, sanitizeFileName } from '../utils/settlementUtils';
import { CargaProps } from '../interfaces/carga-props';

export const useSettlementUpload = (props: CargaProps, agrId: number, setRefresh: (v: boolean) => void) => {
  const upload = async (file: File, item: any) => {
    const periodo = getPeriodoYYYYMM(props.path);

    if (!periodo) {
      props.courier.messageWarning('Debe seleccionar el periodo antes de cargar el archivo');
      return;
    }

    const data = {
      liqins_agrcorliq_id: agrId,
      liqins_path: `SETTLEMENT_FILES/${uuidv4()}`,
      liqins_name_file: sanitizeFileName(file.name),
      liqins_colid: props.user.getCollaboratorId().toString(),
      liqins_fecha_carga: buildFechaCarga(periodo),
      liqins_periodo: periodo,
      liqins_instid: item.inst_id,
      liqins_activo: 1,
    };

    try {
      props.changeBlockUI(true);
      await props.system.getSettlementSystem().UploadfileForm(data, file);

      props.courier.messageSuccess('Archivo cargado correctamente');
    } catch (e) {
      props.courier.messageError(e);
    } finally {
      props.changeBlockUI(false);
      setRefresh(true);
    }
  };

  return { upload };
};
